import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {ReservationCustomFieldValueDTO, ReservationDTO} from "../../../../DTO/PriorAppointment/ReservationDTO";
import {CommunityDTO} from "../../../../DTO/CommunityDTO";
import {ThemeService} from "../../../../services/theme/theme.service";
import jspdf from 'jspdf';
import {TranslateService} from "@ngx-translate/core";
import Swal from "sweetalert2";
import {ApiService} from "../../../../services/api.service";
import {ActivatedRoute, Router} from "@angular/router";
import {CustomFieldDTO} from "../../../../DTO/CustomFieldDTO";
import {CustomFieldsConstants} from "../../../../constants/CustomFieldsConstants";
import { priorAppointmentModuleBasePath } from '../../prior-appointment-route.util';
import { preAppointmentI18nKey } from '../../../../services/prior-appointment/prior-appointment-labels.util';

@Component({
  selector: 'app-finish-reservation',
  templateUrl: './finish-reservation.component.html',
  styleUrl: './finish-reservation.component.scss'
})
export class FinishReservationComponent implements OnInit{
  @Input() nextAttempt = new EventEmitter();
  @Input() itsUpdating:boolean = false;
  @Input() public reservation: ReservationDTO;
  @Input() public community: CommunityDTO;
  @Input() communityModuleId: number | null = null;
  @Input() preReservationLabels = false;
  @ViewChild('content_pdf') content: ElementRef;
  communityName: string;

  // Campos personalizados de la reserva (si en el futuro se exponen desde backend)
  public reservationCustomFields: CustomFieldDTO[] = [];


  constructor(public _themeService: ThemeService,
              public _translate: TranslateService,
              private apiService: ApiService,
              private router: Router,
              private actRoute: ActivatedRoute) {

  }
  ngOnInit(): void {
    this.communityName = this.actRoute.snapshot.params['community'];
  }

  private instantPa(key: string, params?: object): string {
    const resolved = this.preReservationLabels ? preAppointmentI18nKey(key) : key;
    return this._translate.instant(resolved, params);
  }

  get reservationTotalAmount(): number {
    const raw = Number((this.reservation as any)?.totalAmount ?? 0);
    return Number.isFinite(raw) ? Math.max(0, raw) : 0;
  }

  get hasReservationPrice(): boolean {
    return this.reservationTotalAmount > 0;
  }

  get hasAdditionalData(): boolean {
    return !!this.reservation?.customFieldValues?.length;
  }

  get canCancelReservation(): boolean {
    return this.itsUpdating && this.reservation?.reservationCancelable === true;
  }

  getCustomFieldName(cfv: ReservationCustomFieldValueDTO): string {
    const cf = this.reservation?.customFields?.find(f => f.id === cfv.customFieldId);
    return cf?.name ?? cfv?.customFieldName ?? '';
  }

  getCustomFieldDisplayValue(cfv: ReservationCustomFieldValueDTO): string {
    const cf = this.reservation?.customFields?.find(f => f.id === cfv.customFieldId);
    const type = (cf?.type ?? cfv?.customFieldType ?? '').toString().toUpperCase();
    if (type === CustomFieldsConstants.InputTypes.CHECKBOX) {
      const v = (cfv.value ?? '').toString().toLowerCase();
      return v === 'true' || v === '1' ? this.instantPa('PRIORAPPOINTMENTFINISH.yes') : this.instantPa('PRIORAPPOINTMENTFINISH.no');
    }
    return cfv.value ?? '';
  }
  _export() {
    return async () => {
      await this.exportPDF();
    }
  }
  private async exportPDF() {

    let doc = new jspdf({
      orientation: 'p',
      unit: 'pt',
      format: 'a4',
      putOnlyUsedFonts:true,
      precision: 2
    });
    var d = this.reservation.name;
    await doc.html(this.content.nativeElement.innerHTML, {
      autoPaging: "text",
      callback: function (doc) {
        doc.save('Reserva - '+ d +'.pdf');
      },
      width: 500,
      margin: 40,
      windowWidth: 500,
    } );

  }

  public deleteReservation() {
    Swal.fire({
      reverseButtons: true,
      title: this.instantPa('PRIORAPPOINTMENT.deleteConfirmationTitle'),
      text: this.instantPa('PRIORAPPOINTMENT.deleteConfirmationText'),
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: 'green',
      cancelButtonColor: '#2f4050',
      confirmButtonText: this.instantPa('PRIORAPPOINTMENT.confirmButtonText'),
      cancelButtonText: this.instantPa('PRIORAPPOINTMENT.cancelButtonText'),
      preConfirm: (result) => {
        Swal.fire({
          title: this.instantPa('PRIORAPPOINTMENT.deletingReservationTitle'),
          icon: 'info',
          showCancelButton: false,
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
            this.apiService.deleteReservation(this.community.code, this.reservation).toPromise()
                .then((res) => {
                  Swal.fire({
                    title: this.instantPa('PRIORAPPOINTMENT.genericSuccess'),
                    icon: 'success',
                    text: this.instantPa('PRIORAPPOINTMENT.reservationDeleted'),
                    confirmButtonText: this.instantPa('PRIORAPPOINTMENT.genericAccept')
                  });
                  const mid = this.communityModuleId;
                  if (mid != null) {
                    void this.router.navigateByUrl('/' + priorAppointmentModuleBasePath(this.communityName, mid));
                  } else {
                    void this.router.navigate([this.communityName]);
                  }
                })
                .catch(error => {
                  Swal.fire({
                    title: this.instantPa('PRIORAPPOINTMENT.genericError'),
                    icon: 'error',
                    html: this.instantPa('PRIORAPPOINTMENT.genericError'),
                    confirmButtonText: this.instantPa('PRIORAPPOINTMENT.genericAccept')
                  });
                });
          }
        }).then((result) => {
        });
      }
    });
  }


}
